<template>
  <div class="page-card">
    <div class="detail-head">
      <div>
        <h2 class="page-title page-title-inline">任务详情</h2>
        <div class="label-muted">{{ task.taskNo || '-' }}</div>
      </div>
      <div class="detail-actions">
        <el-button @click="$router.push('/ops/message-tasks')">返回列表</el-button>
        <el-button v-if="canCreate" type="primary" @click="$router.push('/ops/message-send')">继续发送</el-button>
      </div>
    </div>

    <div class="summary-grid">
      <div class="summary-card">
        <div class="summary-label">任务名称</div>
        <div class="summary-value">{{ task.taskName || '-' }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">发送对象</div>
        <div class="summary-value">{{ receiverTypeLabel(task.receiverType) }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">任务状态</div>
        <div class="summary-value">{{ taskStatusLabel(task.taskStatus) }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-label">发送结果</div>
        <div class="summary-value">{{ (task.successCount || 0) + (task.failCount || 0) }} 条</div>
      </div>
    </div>

    <el-descriptions :column="2" border class="task-descriptions">
      <el-descriptions-item label="通知标题">{{ task.messageTitle || '-' }}</el-descriptions-item>
      <el-descriptions-item label="发送时间">{{ task.actualSendAt || '-' }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{ task.createdAt || '-' }}</el-descriptions-item>
      <el-descriptions-item label="成功 / 失败">{{ task.successCount || 0 }} / {{ task.failCount || 0 }}</el-descriptions-item>
      <el-descriptions-item label="通知正文" :span="2">
        <div class="message-content">{{ task.messageContent || '-' }}</div>
      </el-descriptions-item>
    </el-descriptions>

    <div class="table-head">
      <h3>发送明细</h3>
      <el-button @click="fetchData">刷新</el-button>
    </div>

    <el-table :data="details" border>
      <el-table-column prop="id" label="明细ID" width="100" />
      <el-table-column label="接收对象" width="100">
        <template slot-scope="{ row }">
          {{ receiverTypeLabel(row.receiverType) }}
        </template>
      </el-table-column>
      <el-table-column prop="receiverUserId" label="用户ID" width="120" />
      <el-table-column prop="receiverSubjectId" label="主体ID" width="120" />
      <el-table-column label="发送状态" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="detailStatusTagType(row.sendStatus)">
            {{ detailStatusLabel(row.sendStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="relatedStationMessageId" label="站内消息ID" width="130" />
      <el-table-column prop="sentAt" label="发送时间" width="180" />
      <el-table-column prop="failReason" label="失败原因" min-width="220" show-overflow-tooltip />
    </el-table>

    <div v-if="details.length === 0" class="empty-state">暂无发送明细</div>
  </div>
</template>

<script>
import { hasPermission } from '../../../utils/auth'
import { getAdminMessageTaskDetail, getAdminMessageTaskDetails } from '../../../api/opsMessage'

export default {
  name: 'OpsMessageTaskDetailPage',
  data() {
    return {
      task: {},
      details: []
    }
  },
  computed: {
    canCreate() {
      return hasPermission('ops_message_task:create')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    receiverTypeLabel(type) {
      const map = {
        1: '艺人',
        2: '商家',
        3: '全部'
      }
      return map[Number(type)] || '-'
    },
    taskStatusLabel(status) {
      const map = {
        2: '待发送',
        3: '发送中',
        4: '已完成',
        5: '部分失败'
      }
      return map[Number(status)] || '处理中'
    },
    detailStatusLabel(status) {
      const map = {
        1: '待发送',
        2: '成功',
        3: '失败'
      }
      return map[Number(status)] || '处理中'
    },
    detailStatusTagType(status) {
      const map = {
        1: 'info',
        2: 'success',
        3: 'danger'
      }
      return map[Number(status)] || 'info'
    },
    async fetchData() {
      const id = this.$route.params.id
      const [task, details] = await Promise.all([
        getAdminMessageTaskDetail(id).catch(() => ({})),
        getAdminMessageTaskDetails(id).catch(() => [])
      ])
      this.task = task || {}
      this.details = Array.isArray(details) ? details : []
    }
  }
}
</script>

<style scoped>
.detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.page-title-inline {
  margin-bottom: 6px;
}

.detail-actions {
  display: flex;
  gap: 12px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin: 20px 0;
}

.summary-card {
  padding: 18px;
  border-radius: 8px;
  background: #f7f9fc;
}

.summary-label {
  color: #909399;
  font-size: 13px;
}

.summary-value {
  margin-top: 10px;
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}

.task-descriptions {
  margin-bottom: 20px;
}

.message-content {
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}

.table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.table-head h3 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}

.empty-state {
  padding: 24px 0 4px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}
</style>
